import '@carry0987/pincode-input/dist/pincodeInput.min.js';

import '@cm/styles/images/confirmation.svg';
import '@cm/styles/images/logos-customer.svg';
import '@cm/styles/images/logo-customer-classdojo.png';
import '@cm/styles/images/goodbye.png';
import '@cm/styles/images/link-sent.svg';
import '@cm/styles/devise.scss';
